module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (1).d5783a29.jpg";